module.exports = __webpack_public_path__ + "img/10.acbf48bc.jpg";